/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=49d461b5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=49d461b5&lang=less&scoped=true"

import exportComponent from "D:\\dianzhong\\cps-expert-popularize\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d461b5"]])

export default __exports__